import { Link, Typography } from "@material-ui/core";
import { FC } from "react";

import colors from "../../../theme/colors";
import { parseTextWithUrl } from "../utils";

const TextWithUrl: FC<TextWithUrlProps> = ({ text, isReceivedMessage }) => {
  return (
    <>
      {parseTextWithUrl(text).map((entry: { text: string; isUrl: boolean }) => (
        <>
          {entry.isUrl ? (
            <Link
              href={entry.text}
              target="_blank"
              style={{
                color: isReceivedMessage ? "#000" : colors.text.light,
                textDecoration: "underline",
                display: "inline",
              }}
            >
              {entry.text}
            </Link>
          ) : (
            <Typography
              style={{
                whiteSpace: "pre-line",
                color: isReceivedMessage ? "#000" : colors.text.light,
                display: "inline",
              }}
            >
              {entry.text}
            </Typography>
          )}{" "}
        </>
      ))}
    </>
  );
};

interface TextWithUrlProps {
  text: string;
  isReceivedMessage: boolean;
}

export default TextWithUrl;
